export default __webpack_public_path__ + "static/i360-9faeb10536fa8e23dd06b6c6f92957f2.jpg";